import React, { useState } from 'react';
import Popup from "../imagepopup";


function Ford() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };



  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p49.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
                <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                Designed and developed a Pega-based Service Scheduling System for Ford’s Customer and Dealer Portals, enhancing the end-to-end vehicle service booking experience. The Customer Portal enabled users to seamlessly schedule service appointments, select service centers, receive real-time updates, and track service history, while the Dealer Portal facilitated appointment management, resource allocation, service approvals, and status tracking.</p>
                <p className="mt-15">
                Led the UI/UX design and development, ensuring a responsive, intuitive, and visually engaging interface using Pega UI components, dynamic layouts, section-based design, and customized skin rules. Focused on user-centric design principles, improving accessibility, navigation, and overall user experience across web and mobile platforms.</p>
<p className="mt-15">Implemented intelligent workflow automation with Pega Case Management and Decisioning, optimizing scheduling, reducing manual intervention, and ensuring real-time service slot availability. Integrated REST APIs to fetch vehicle details, service history, and dealer-specific availability. Performed performance tuning and scalability optimizations to enhance system responsiveness.</p>
<p className="mt-15">This project significantly improved service appointment efficiency, reduced wait times, and strengthened customer-dealer coordination, contributing to Ford’s digital transformation and customer experience enhancement strategy</p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>

                  <p>As a <strong>UI/UX Lead </strong>for multiple UI teams in the <strong>Ford Motors</strong> Pega project, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">UI/UX Strategy & Design: Led the design and development of a seamless, responsive, and intuitive Pega-based user interface for both the Customer and Dealer Portals.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">UI Development & Customization: Designed dynamic layouts, sections, and custom skin rules to ensure a visually appealing and user-friendly experience.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Cross-Team Collaboration: Coordinated with business analysts, developers, and stakeholders to align UI/UX designs with business goals and technical feasibility.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">User Experience Optimization: Conducted usability testing, accessibility enhancements, and iterative UI improvements based on user feedback.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Performance Optimization: Ensured efficient UI rendering, optimized rule configurations, and implemented best practices for UI performance in Pega.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">API Integration Support: Worked closely with backend teams to integrate REST APIs for real-time service booking and dealer updates.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Designed Out of box Custom components that were scalable and
                      reusable across all future projects.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Developing customized Pega Skin for all applications across all
Pega Labs for Ford and creating Responsive Interface with
customized UI components based on application requirements.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Analyzed and reviewed whether Ford Branding Guidelines are
                      maintained for the UI Components developed on the Pega Platform.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Agile Development & Leadership: Managed multiple UI teams, conducted code reviews, and ensured adherence to best practices in Pega UI/UX development.</h6>
                    </li>
                   
                  </ul>
                  <p className="mt-25">
                  This role was critical in delivering a modernized, user-friendly service scheduling platform, significantly enhancing the customer and dealer experience for Ford Motors.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>9, August 2022</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Lead</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Ford Motors</p>
                  </li>
                
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p50.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p50.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p52.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p52.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p51.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p51.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p53.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p53.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/sunlife">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
                        
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Ford;
